import { Container } from "@/components/layout/Container"
import { Eyebrow } from "@/components/shared/Eyebrow"
import type { ProductImage } from "@/content/products"

interface TreatmentHowItWorksProps {
	/** Nombre del padecimiento en minúscula, ej. "acné". */
	condition: string
	how: string
	/** Foto del tratamiento (URL ya resuelta con `imageBaseURL`). */
	image: ProductImage
}

/**
 * Sección "Cómo funciona": explica cómo actúa la bioestimulación celular en el
 * padecimiento, con la foto del tratamiento a un lado. Usa el `Eyebrow` (mismo
 * estilo que el Hero de inicio) en lugar de una etiqueta tipo badge.
 */
export function TreatmentHowItWorks({ condition, how, image }: TreatmentHowItWorksProps): React.JSX.Element {
	return (
		<section className="bg-background">
			<Container className="py-16 md:py-24">
				<div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
					<img
						src={image.source}
						alt={image.alt}
						className="aspect-4/3 w-full rounded-card object-cover"
						loading="lazy"
					/>
					<div className="text-center lg:text-left">
						<Eyebrow align="center" className="lg:text-left">
							Cómo funciona
						</Eyebrow>
						<h2 className="mt-3 text-balance font-heading text-2xl font-semibold tracking-tight sm:text-3xl md:text-4xl">
							Bioestimulación celular para {condition}
						</h2>
						<p className="mx-auto mt-6 max-w-xl text-pretty text-lg leading-relaxed text-muted-foreground lg:mx-0">
							{how}
						</p>
					</div>
				</div>
			</Container>
		</section>
	)
}
